/**
 * Customized Tooltip component.
 *
 * Reference: https://chakra-ui.com/docs/theming/customize-theme
 * Figma Reference: https://www.figma.com/file/OICZImstt1c5S683bSjvj9/Components?node-id=85%3A2617
 */

import { cssVar } from '@chakra-ui/react';

import colors from '../foundation/colors';

const $bg = cssVar('tooltip-bg');
const $arrowBg = cssVar('popper-arrow-bg');

const Tooltip = {
  basStyle: {},
  variants: {
    dark: {
      bg: 'greyScale.900',
      color: 'white'
    },
    light: {
      bg: 'greyScale.200',
      color: 'greyScale.900',
      [$arrowBg.variable]: 'greyScale.200'
    },
    success: () => {
      const bg = colors.success.primary['600'];

      return {
        [$bg.variable]: bg,
        bg: [$bg.reference],
        [$arrowBg.variable]: [$bg.reference],
        borderRadius: 'md',
        color: 'white'
      };
    },
    error: () => {
      const bg = colors.error.primary['600'];

      return {
        [$bg.variable]: bg,
        bg: [$bg.reference],
        [$arrowBg.variable]: [$bg.reference],
        borderRadius: 'md',
        color: 'white'
      };
    },
    archived: () => {
      const bg = colors.greyScale['700'];

      return {
        [$bg.variable]: bg,
        bg: [$bg.reference],
        [$arrowBg.variable]: [$bg.reference],
        borderRadius: 'md',
        color: 'white'
      };
    }
  },
  sizes: {
    medium: {
      borderRadius: 'lg',
      textStyle: 'bodyXs500',
      fontSize: '13px',
      boxShadow: '0px 4px 10px rgba(147, 164, 187, 0.4), 0px 8px 6px rgba(100, 132, 162, 0.25)',
      padding: '8px 16px'
    }
  },
  defaultProps: {
    variant: 'dark',
    size: 'medium'
  }
};

export default Tooltip;
